<template src="./Detalhe.html"></template>
<style lang="scss" scoped src="./Detalhe.scss"></style>

<script>
import { translate } from '../../../services/translate.service';
import service from '../../../services/qrcode.service';
import * as helper from '../helper';
import { VCarousel, VCarouselItem } from 'vuetify/lib'
import QrcodeVue from 'qrcode.vue'
import { types } from '../../../store';
export default {
  name: 'bilhete-especial-detalhe',
  props:{
    data:{
      type: Object
    },
  },
  components: {
    QrcodeVue,
    VCarousel,
    VCarouselItem
  },
  data() {
    return {
      loaded: false,
      processing: false,
      dataUrl: null,
      service,
      slideAtivo: 0,
      helper,
      qrCodesBase64: [],
      canvasImageOld: null,
      config: {
        size: 256,
        level: 'M',
        padding: 20,
        class: 'qrcode-bilhete'
      }
    }
  },
  computed: {
    current() {
      return this.$store.state.qrcode_current || null;
    },
    item () {
      return this.$store.state.qrcode_detalhe || null;
    },
    itemsDisponiveis() {
      return (this.$store.state.qrcode_comprados || []).filter(x => x.status == 3);
    },
  },
  methods: {
    t:translate,
    addPaddingToCanvas(canvasOriginal) {
      const padding = this.config.padding;
      const novaLargura = canvasOriginal.width + padding * 2;
      const novaAltura = canvasOriginal.height + padding * 2;

      const canvasComPadding = document.createElement('canvas');
      canvasComPadding.width = novaLargura;
      canvasComPadding.height = novaAltura;
      const contextoComPadding = canvasComPadding.getContext('2d');

      contextoComPadding.fillStyle = 'white';
      contextoComPadding.fillRect(0, 0, novaLargura, novaAltura);
      contextoComPadding.drawImage(canvasOriginal, padding, padding);

      return canvasComPadding.toDataURL();
    },
    /*getQrCode(index) {
      let item = this.qrCodesBase64.find(x => x.index == index);
      return item != null ? item.base64 : null;
    },*/
    handleSlideChange(newIndex) {
      if (this.slideAtivo !== newIndex) {
        this.slideAtivo = newIndex;
      }
    },
    gerarPdf(bilhete/*, index = 0*/) {
      this.processing = true;
      //let dataUrl = this.getQrCode(index);
      service.getQRCodePDF(bilhete.qrcode).then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `bilhete-${ bilhete.qrCodeId.replace(/\./gmi,'') }.pdf`; // Nome do arquivo para download
        a.click();
        window.URL.revokeObjectURL(url);
      }).catch((err) => {
        this.$store.dispatch(types.MODAL_ALERT, { dialog: true, title: "Erro", message: translate('QRCODE_ERRO_BAIXAR_PDF', [err]) });
      }).finally(() => {
        this.processing = false;
      });
    }
  },
  mounted(){
    if(!this.current || !this.item) {
      this.$router.push({ name: 'home' });
      return;
    }
    this.$nextTick(async () => {
      this.slideAtivo = this.itemsDisponiveis.findIndex((v) => {
        return this.item.qrCodeId == v.qrCodeId;
      });
      this.itemsDisponiveis.forEach(async (item, index) => {
        const refName = 'biqrcode_' + index;
        if (this.$refs[refName] && this.$refs[refName][0]) {
          const canvasOriginal = this.$refs[refName][0].$el.querySelector("canvas");
          const dataURL = await this.addPaddingToCanvas(canvasOriginal);
          this.qrCodesBase64.push({
            index,
            base64: dataURL
          });
        }
      });
    })
  }
}
</script>
